export default "__VITE_ASSET__BkdTaoUN__"